import { IFetchSODConflictsBody } from "../../../common/SODUtils/SODconstants";
import { IOfficeItemProps } from "../../../components/OfficesList/module/constants";
import {
  IBREntitlementManagementItem,
  IBRManagementItemInternal,
} from "./models";

export const actionTypes = {
  SELECT_OFFICE: "SELECT_OFFICE",
  SELECT_BR: "SELECT_BR",
  SET_BR_NAME: "SET_BR_NAME",
  SET_BR_DESCRIPTION: "SET_BR_DESCRIPTION",
  SET_ENTITLEMENTS_BR: "SET_ENTITLEMENTS_BR",
  SET_CHAIN_ENTITLEMENTS_BR: "SET_CHAIN_ENTITLEMENTS_BR",
  OFFICE_REQUEST_BR_MANAGEMENT: "OFFICE_REQUEST_BR_MANAGEMENT",
  OFFICE_REQUEST_BR_MANAGEMENT_SUCCESS: "OFFICE_REQUEST_BR_MANAGEMENT_SUCCESS",
  OFFICE_REQUEST_BR_MANAGEMENT_FAILURE: "OFFICE_REQUEST_BR_MANAGEMENT_FAILURE",
  BR_BY_OFFICE_REQUEST: "BR_BY_OFFICE_REQUEST",
  BR_BY_OFFICE_REQUEST_SUCCESS: "BR_BY_OFFICE_REQUEST_SUCCESS",
  BR_BY_OFFICE_REQUEST_FAILURE: "BR_BY_OFFICE_REQUEST_FAILURE",
  ENTITLEMENT_BY_OU_REQUEST: "ENTITLEMENT_BY_OU_REQUEST",
  ENTITLEMENT_BY_OU_REQUEST_SUCCESS: "ENTITLEMENT_BY_OU_REQUEST_SUCCESS",
  ENTITLEMENT_BY_OU_REQUEST_FAILURE: "ENTITLEMENT_BY_OU_REQUEST_FAILURE",
  GET_BR_ENTITLEMENTS: "GET_BR_ENTITLEMENTS",
  GET_BR_ENTITLEMENTS_SUCCESS: "GET_BR_ENTITLEMENTS_SUCCESS",
  GET_BR_ENTITLEMENTS_FAILURE: "GET_BR_ENTITLEMENTS_FAILURE",
  CREATE_BR_REQUEST: "CREATE_BR_REQUEST",
  CREATE_BR_REQUEST_SUCCESS: "CREATE_BR_REQUEST_SUCCESS",
  CREATE_BR_REQUEST_FAILURE: "CREATE_BR_REQUEST_FAILURE",
  MODIFY_BR_REQUEST: "MODIFY_BR_REQUEST",
  MODIFY_BR_REQUEST_SUCCESS: "MODIFY_BR_REQUEST_SUCCESS",
  MODIFY_BR_REQUEST_FAILURE: "MODIFY_BR_REQUEST_FAILURE",
  DELETE_BR_REQUEST: "DELETE_BR_REQUEST",
  DELETE_BR_REQUEST_SUCCESS: "DELETE_BR_REQUEST_SUCCESS",
  DELETE_BR_REQUEST_FAILURE: "DELETE_BR_REQUEST_FAILURE",
  RESET_STATE_BR_MANAGEMENT: "RESET_STATE_BR_MANAGEMENT",
  RESET_BR: "RESET_BR",
  SOD_CONFLICTS_BR: "SOD_CONFLICTS_BR",
  SOD_CONFLICTS_BR_SUCCESS: "SOD_CONFLICTS_BR_SUCCESS",
  SOD_CONFLICTS_BR_FAILURE: "SOD_CONFLICTS_BR_FAILURE",
  RESET_SOD_CONFLICTS_BR: "RESET_SOD_CONFLICTS_BR",
};

export const selectOffice = (payload: IOfficeItemProps) => ({
  type: actionTypes.SELECT_OFFICE,
  payload,
});

export const selectBR = (payload: IBRManagementItemInternal) => ({
  type: actionTypes.SELECT_BR,
  payload,
});

export const setBRName = (payload: string) => ({
  type: actionTypes.SET_BR_NAME,
  payload,
});

export const setBRDescription = (payload: string) => ({
  type: actionTypes.SET_BR_DESCRIPTION,
  payload,
});

export const setEntitlementsBR = (payload: IBREntitlementManagementItem[]) => ({
  type: actionTypes.SET_ENTITLEMENTS_BR,
  payload,
});

export const setChainEntitlementsBR = (payload: string[]) => ({
  type: actionTypes.SET_CHAIN_ENTITLEMENTS_BR,
  payload,
});

export const officeRequest = () => ({
  type: actionTypes.OFFICE_REQUEST_BR_MANAGEMENT,
});

export const officeRequestSuccess = (payload: IOfficeItemProps[]) => ({
  type: actionTypes.OFFICE_REQUEST_BR_MANAGEMENT_SUCCESS,
  payload,
});

export const officeRequestFailure = (err: Error) => ({
  type: actionTypes.OFFICE_REQUEST_BR_MANAGEMENT_FAILURE,
  err,
});

export const brByOfficeRequest = (payload: string) => ({
  type: actionTypes.BR_BY_OFFICE_REQUEST,
  payload,
});

export const brByOfficeRequestSuccess = (payload: any) => ({
  type: actionTypes.BR_BY_OFFICE_REQUEST_SUCCESS,
  payload,
});

export const brByOfficeRequestFailure = (err: Error) => ({
  type: actionTypes.BR_BY_OFFICE_REQUEST_FAILURE,
  err,
});

export const entitlementByOURequest = (payload: string) => ({
  type: actionTypes.ENTITLEMENT_BY_OU_REQUEST,
  payload,
});

export const entitlementByOURequestSuccess = (payload: string) => ({
  type: actionTypes.ENTITLEMENT_BY_OU_REQUEST_SUCCESS,
  payload,
});

export const entitlementByOURequestFailure = (err: Error) => ({
  type: actionTypes.ENTITLEMENT_BY_OU_REQUEST_FAILURE,
  err,
});

export const createBRRequest = (payload: {}) => ({
  type: actionTypes.CREATE_BR_REQUEST,
  payload,
});

export const createBRRequestSuccess = (payload: any) => ({
  type: actionTypes.CREATE_BR_REQUEST_SUCCESS,
  payload,
});

export const createBRRequestFailure = (error: any) => ({
  type: actionTypes.CREATE_BR_REQUEST_FAILURE,
  error,
});

export const modifyBRRequest = (payload: {}) => ({
  type: actionTypes.MODIFY_BR_REQUEST,
  payload,
});

export const modifyBRRequestSuccess = (payload: any) => ({
  type: actionTypes.MODIFY_BR_REQUEST_SUCCESS,
  payload,
});

export const modifyBRRequestFailure = (error: any) => ({
  type: actionTypes.MODIFY_BR_REQUEST_FAILURE,
  error,
});

export const deleteBRRequest = (payload: string, formdata: FormData) => ({
  type: actionTypes.DELETE_BR_REQUEST,
  payload,
  formdata,
});
export const deleteBRRequestSuccess = (payload: any) => ({
  type: actionTypes.DELETE_BR_REQUEST_SUCCESS,
  payload,
});

export const deleteBRRequestFailure = (err: Error) => ({
  type: actionTypes.DELETE_BR_REQUEST_FAILURE,
  err,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE_BR_MANAGEMENT,
});

export const resetBR = () => ({
  type: actionTypes.RESET_BR,
});

export const sodConflictsActionBR = (payload: IFetchSODConflictsBody) => ({
  type: actionTypes.SOD_CONFLICTS_BR,
  payload,
});

export const sodConflictsActionBRSuccess = (payload: any[]) => ({
  type: actionTypes.SOD_CONFLICTS_BR_SUCCESS,
  payload,
});

export const sodConflictsActionBRFailure = (err: Error) => ({
  type: actionTypes.SOD_CONFLICTS_BR_FAILURE,
  err,
});

export const resetSodConflictsActionBR = () => ({
  type: actionTypes.RESET_SOD_CONFLICTS_BR,
});

export const getBrEntitlementsAction = (payload: string) => ({
  type: actionTypes.GET_BR_ENTITLEMENTS,
  payload,
});

export const getBrEntitlementsActionSuccess = (payload: any) => ({
  type: actionTypes.GET_BR_ENTITLEMENTS_SUCCESS,
  payload,
});

export const getBrEntitlementsActionFailure = (error: any) => ({
  type: actionTypes.GET_BR_ENTITLEMENTS_FAILURE,
  error,
});
